import Vue from 'vue'
import Vuex from 'vuex'
import invoices from '../store/modules/invoices'
import partners from "../store/modules/partners"
import banks from "../store/modules/banks";
import settings from "@/store/modules/settings";
import auth from "@/store/modules/auth";
import clients from "@/store/modules/clients";

Vue.use(Vuex)

let store = new Vuex.Store({
    modules: {
        clients,
        invoices,
        partners,
        banks,
        settings,
        auth
    },
})

export default store
